import type {
  PaalaegDetailModel,
  PaalaegIndberetningOverviewModel,
} from "@/interfaces/paalaeg";
import { get, getBlob, getWithErrorObject } from "./util";

const PAALAEG_QUERY = "Paalaeg";

export const PAALAEG_QUERY_KEY = ["paalaeg"] as const;

export const createPaalaegDetailQueryKey = (id: string) =>
  [...PAALAEG_QUERY_KEY, "detail", id] as const;

export const getAllPaalaegIndberetninger = (): Promise<
  PaalaegIndberetningOverviewModel[]
> =>
  get<PaalaegIndberetningOverviewModel[]>({
    query: `${PAALAEG_QUERY}/HentAllePaalaegIndberetninger`,
  });

export const getPaalaeg = (id: string): Promise<PaalaegDetailModel> =>
  getWithErrorObject<PaalaegDetailModel>({
    query: `${PAALAEG_QUERY}/HentPaalaeg/${id}`,
  });

export const fetchPaalaegDocumentFile = (id: string): Promise<Blob> =>
  getBlob({
    query: `${PAALAEG_QUERY}/HentPaalaeg/${id}/download`,
  });
